import * as Base from "./generated";
export * from "./generated";
export class DealerKitClient {
    constructor(configuration = {}) {
        this.configuration = new Base.Configuration(configuration);
        this.company = new Base.CompanyApi(this.configuration);
        this.auth = new Base.AuthApi(this.configuration);
        this.advertising = new Base.AdvertisingApi(this.configuration);
        this.assistant = new Base.AssistantApi(this.configuration);
        this.utilities = new Base.UtilitiesApi(this.configuration);
        this.stockList = new Base.StockListApi(this.configuration);
        this.jobs = new Base.JobsApi(this.configuration);
        this.inspections = new Base.InspectionsApi(this.configuration);
        this.reportTemplates = new Base.ReportTemplatesApi(this.configuration);
        this.reporting = new Base.ReportingApi(this.configuration);
        this.accountingExports = new Base.AccountingExportsApi(this.configuration);
        this.financeSettlements = new Base.FinanceSettlementsApi(this.configuration);
        this.financeContras = new Base.FinanceContrasApi(this.configuration);
        this.financeCommission = new Base.FinanceCommissionApi(this.configuration);
        this.valuations = new Base.ValuationsApi(this.configuration);
        this.advertisingChannels = new Base.AdvertisingChannelsApi(this.configuration);
        this.users = new Base.UsersApi(this.configuration);
        this.vehicles = new Base.VehiclesApi(this.configuration);
        this.appraisals = new Base.VehicleAppraisalsApi(this.configuration);
        this.leads = new Base.LeadsApi(this.configuration);
        this.leadPipelines = new Base.LeadPipelinesApi(this.configuration);
        this.leadStages = new Base.LeadStagesApi(this.configuration);
        this.writeDowns = new Base.WriteDownsApi(this.configuration);
        this.contacts = new Base.ContactsApi(this.configuration);
        this.expenses = new Base.ExpensesApi(this.configuration);
        this.products = new Base.ProductsApi(this.configuration);
        this.accounting = new Base.AccountingApi(this.configuration);
        this.locations = new Base.LocationsApi(this.configuration);
        this.teams = new Base.TeamsApi(this.configuration);
        this.crm = new Base.CRMApi(this.configuration);
        this.inbox = new Base.InboxApi(this.configuration);
        this.settings = new Base.SettingsApi(this.configuration);
        this.deals = new Base.DealsApi(this.configuration);
        this.documents = new Base.DocumentsApi(this.configuration);
        this.parts = new Base.PartsApi(this.configuration);
        this.preparation = new Base.PreparationApi(this.configuration);
        this.kits = new Base.KitsApi(this.configuration);
        this.analytics = new Base.AnalyticsApi(this.configuration);
        this.offers = new Base.OffersApi(this.configuration);
        this.templates = new Base.TemplatesApi(this.configuration);
        this.changelog = new Base.ChangelogApi(this.configuration);
    }
}
export const StockListingStatusCode = {
    DueIn: 5,
    InStock: 10,
    Reserved: 15,
    AwaitingDelivery: 20,
    Sold: 25,
    NonStock: 100,
};
